import { LanguageSelectionHelper } from "app/helpers/languageSelectionHelper";
// import type { EventType } from "../../types/eventType";
import { SessionHelper } from "app/helpers/sessionHelper";
import isEmpty from "lodash/isEmpty";
import { $Values } from "utility-types";
import * as api from "../../api/profileApi";
import { PersonalDetailsType } from "../../types/reportType";
const ProfileModel = {
  state: {
    account: {} as {},
    isLoading: true,
  },
  reducers: {
    setAccountSuccess(
      state: Record<string, any>,
      payload: $Values<typeof PersonalDetailsType>[]
    ): any {
      return { ...state, isLoading: false, account: payload };
    },

    setAccountRequest(
      state: Record<string, any>,
      payload: $Values<typeof PersonalDetailsType>[]
    ): any {
      return { ...state, isLoading: true, account: payload };
    },
  },
  effects: {
    async loadAccount(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ) {
      this.setAccountRequest();
      api.fetchAccountDetails().then(resp => {
        const account: $Values<typeof PersonalDetailsType>[] = resp;

        if (!isEmpty(account)) {
          this.setAccountSuccess(account);
        }
      });
    },

    async onLanguageChange(lang: string, rootState: Record<string, any>) {
      if (!SessionHelper.isAuthenticated()) {
        LanguageSelectionHelper.saveLanguageToCookie(lang);
        LanguageSelectionHelper.saveLanguageChangedToCookie(true);

        // reload window with new selected language
        window.location.reload();
      } else {
        api
          .updateLanguage(
            rootState.userModel.user["userId"],
            rootState.userModel.user["accountId"],
            rootState.userModel.user.preferences["oddsType"],
            lang
          )
          .then(resp => {
            LanguageSelectionHelper.saveLanguageToCookie(
              resp.preferences.language
            );
            // reload window with new selected language
            window.location.reload();
          });
      }
    },
  },
};
export default ProfileModel;
